import { render, staticRenderFns } from "./GeneralSegmentForm.vue?vue&type=template&id=0382f394"
import script from "./GeneralSegmentForm.vue?vue&type=script&lang=js"
export * from "./GeneralSegmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports